import React from 'react';
import { Icon } from '@chakra-ui/react';
import { CheckCircleFill } from '@styled-icons/bootstrap/CheckCircleFill';

export const IconBetPlaced = () => (
  <Icon as={CheckCircleFill} boxSize="3" ml="1" color="green.500" />
);
